var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"rtl":_vm.$vs.rtl,"star-size":25,"border-width":2,"disable":true,"border-color":"#d8d8d8","active-color":"#00c226","rounded-corners":false,"star-points":[
          23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46,
          19, 31, 17,
        ],"read-only":true,"show-rating":false},model:{value:(_vm.rateValue),callback:function ($$v) {_vm.rateValue=$$v},expression:"rateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }